import { Observable } from 'rxjs';
import { CustomerSettings } from '../../models/customer-settings';

export abstract class ICustomerSettingsService {
    public abstract get(bkCustomerKey: string): Observable<CustomerSettings | undefined>
    public abstract create(customerSettings: CustomerSettings): Observable<unknown>
    public abstract update(customerSettings: CustomerSettings): Observable<unknown>
}
